<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Rutas</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Administrativo</li>
                  <li class="breadcrumb-item active">Básico</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Rutas</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-11"></div>
                  <div class="col-md-1">
                    <div class="btn-group float-right">
                      <!-- SE LLAMA A LA VISTA PARA UNA TABLA DINAMICA -->
                      <button
                        type="button"
                        class="btn btn-info"
                        @click="pivotTable()"
                        v-if="$store.getters.can('admin.rutas.pivotTable')"
                      >
                        <i class="fas fa-scroll"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-success"
                        data-toggle="modal"
                        data-target="#modal_form_ruta_export"
                        v-if="$store.getters.can('admin.rutas.export')"
                      >
                        <i class="far fa-file-excel"></i>
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="create()"
                        v-if="$store.getters.can('admin.rutas.create')"
                      >
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="row justify-content-center">
                  <div class="form-group col-md-4">
                    <label>Nombre Ruta:</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filtros.nombre"
                      @keyup.enter="getIndex()"
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label>Origen:</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.origen_id"
                      label="nombre"
                      class="form-control form-control-sm p-0"
                      :options="listasForms.origenes"
                      :filterable="false"
                      @search="buscarOrigenes"
                      @input="getIndex()"
                      :reduce="(o) => o.id"
                    ></v-select>
                  </div>
                  <div class="form-group col-md-4">
                    <label>Destino:</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.destino_id"
                      label="nombre"
                      class="form-control form-control-sm p-0"
                      :options="listasForms.destinos"
                      :filterable="false"
                      @search="buscarDestinos"
                      @input="getIndex()"
                      :reduce="(d) => d.id"
                    ></v-select>
                  </div>
                  <div class="form-group col-md-2">
                    <label>Código:</label>
                    <input
                      type="text"
                      class="form-control form-control-sm"
                      v-model="filtros.codigo"
                      @keyup.enter="getIndex()"
                    />
                  </div>
                  <div class="form-group col-md-4">
                    <label>Despachado a:</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.despachado_a_id"
                      label="descripcion"
                      class="form-control form-control-sm p-0"
                      :options="listasForms.despachados"
                      :filterable="true"
                      :reduce="(da) => da.numeracion"
                      @input="getIndex()"
                    ></v-select>
                  </div>
                  <div class="form-group col-md-2">
                    <label>Horas Vigencia:</label>
                    <input
                      type="number"
                      min="0"
                      class="form-control form-control-sm"
                      v-model="filtros.horas_vigencia"
                      @keyup.enter="getIndex()"
                    />
                  </div>
                  <div class="form-group col-md-2">
                    <label>Tipo Ruta:</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="filtros.tipo_ruta"
                      label="descripcion"
                      class="form-control form-control-sm p-0"
                      :options="listasForms.tipoRutas"
                      :filterable="true"
                      :reduce="(tr) => tr.numeracion"
                      @input="getIndex()"
                    ></v-select>
                  </div>
                  <div class="form-group text-right col-md-2">
                    <div class="btn-group pt-4">
                      <button
                        type="button"
                        class="btn bg-navy"
                        @click="getIndex()"
                      >
                        <i class="fas fa-search"></i></button
                      ><button
                        type="button"
                        class="btn btn-danger"
                        @click="limpiarForm()"
                      >
                        <i class="fas fa-broom"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body table-responsive p-0">
                <table
                  class="table table-bordered table-striped table-hover table-sm"
                >
                  <thead class="bg-dark">
                    <tr>
                      <th>Nombre Ruta</th>
                      <th>Origen</th>
                      <th>Destino</th>
                      <th class="col-1">Código</th>
                      <th class="col-3">Despachado A</th>
                      <th class="col-1">Vigencia</th>
                      <th>Tipo de Ruta</th>
                      <th class="col-1">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="ruta in rutas.data" :key="ruta.id">
                      <td>{{ ruta.nombre }}</td>
                      <td>{{ ruta?.origen?.nombre ?? "" }}</td>
                      <td>{{ ruta?.destino?.nombre ?? "" }}</td>
                      <td class="text-center">{{ ruta.codigo }}</td>
                      <td class="text-center">
                        <span
                          v-if="ruta.despachado_a_id"
                          class="badge bg-light"
                          >{{ ruta.nDespachadoA }}</span
                        >
                        <div v-else class="row justify-content-center" >
                          <span
                            v-for="despa in ruta.rutas_despachados"
                            :key="despa.numeracion"
                            class="badge bg-light m-1"
                          >
                            {{ despa.descripcion }}</span
                          >
                        </div>
                      </td>
                      <td class="text-center">
                        {{ ruta.horas_vigencia }} <small>(horas)</small>
                      </td>
                      <td class="text-center">{{ ruta.ntipo_ruta }}</td>
                      <td>
                        <div class="btn-group float-right">
                          <button
                            type="button"
                            class="btn btn-sm bg-navy"
                            v-if="$store.getters.can('admin.rutas.show')"
                            @click="edit(ruta)"
                          >
                            <i class="fas fa-edit"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            v-if="$store.getters.can('admin.rutas.delete')"
                            @click="destroy(ruta.id)"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="rutas.total">
                  Mostrando del <b>{{ rutas.from }}</b> al
                  <b>{{ rutas.to }}</b> de un total:
                  <b>{{ rutas.total }}</b> Registros
                </div>
                <div class="float-left" v-else>
                  <span class="badge badge-danger">
                    No hay registros para mostrar
                  </span>
                </div>
                <pagination
                  :data="rutas"
                  @pagination-change-page="getIndex"
                  :limit="5"
                  class="float-right m-0"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <RutaExport ref="RutaExport" />
  </div>
</template>

<script>
import loading from "@/components/Loading.vue";
import vSelect from "vue-select";
import axios from "axios";
import pagination from "laravel-vue-pagination";
import RutaExport from "./RutaExport";

export default {
  name: "RutaIndex",
  components: {
    loading,
    pagination,
    vSelect,
    RutaExport,
  },
  data() {
    return {
      cargando: false,
      rutas: {},
      filtros: {
        nombre: null,
        codigo: null,
        origen_id: null,
        destino_id: null,
        despachado_a_id: null,
        horas_vigencia: null,
        tipo_ruta: null,
      },
      listasForms: {
        origenes: [],
        destinos: [],
        despachados: [],
        tipoRutas: [],
      },
    };
  },
  methods: {
    getIndex(page = 1) {
      this.cargando = true;
      axios
        .get("/api/admin/rutas?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.rutas = response.data;
          this.cargando = false;
        })
        .catch((error) => {
          this.$swal({
            icon: "error",
            title: "Ocurrió un error: " + error,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
    limpiarForm() {
      this.filtros = {
        nombre: null,
        codigo: null,
        origen_id: null,
        destino_id: null,
        despachado_a_id: null,
        horas_vigencia: null,
        tipo_ruta: null,
      };
      this.listasForms.origenes = [];
      this.listasForms.destinos = [];
      this.getIndex();
    },
    getTipoRutas() {
      axios.get("/api/lista/48").then((response) => {
        this.listasForms.tipoRutas = response.data;
      });
    },
    getDespachados() {
      axios.get("/api/lista/54").then((response) => {
        this.listasForms.despachados = response.data;
      });
    },
    buscarOrigenes(search, loading) {
      if (search != "") {
        loading(true);
        axios
          .get("api/admin/sitios/lista?sitio=" + search)
          .then((response) => {
            this.listasForms.origenes = response.data;
            loading(false);
          })
          .catch((error) => {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },
    buscarDestinos(search, loading) {
      if (search != "") {
        loading(true);
        axios
          .get("api/admin/sitios/lista?sitio=" + search)
          .then((response) => {
            this.listasForms.destinos = response.data;
            loading(false);
          })
          .catch((error) => {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
            loading(false);
          });
      }
    },
    create() {
      return this.$router.push({
        name: "/Admin/RutaForm",
        params: { accion: "Crear", id: null, filtros: this.filtros },
      });
    },
    edit(ruta) {
      return this.$router.push({
        name: "/Admin/RutaForm",
        params: { accion: "Editar", data_edit: ruta, id: ruta.id, filtros: this.filtros },
      });
    },
    destroy(idRuta) {
      this.$swal({
        title: "Esta seguro de eliminar esta Ruta?",
        text: "Los cambios no se pueden revertir!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, Eliminar!",
      }).then((result) => {
        if (result.value) {
          axios.delete("/api/admin/rutas/" + idRuta).then(() => {
            this.getIndex();
            this.$swal({
              icon: "success",
              title: "Se elimino la Ruta exitosamente...",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
            });
          });
        }
      });
    },
    pivotTable() {
      return this.$router.push({
        name: "/Admin/RutaPivotTable",
      });
    },
  },

  beforeMount() {
    this.getTipoRutas();
    this.getDespachados();
  },

  mounted() {
    if (this.$route.params.filtros) {
      this.filtros = this.$route.params.filtros;
    }
    this.getIndex();
  },
};
</script>
